import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/style-component/components/cardBodyStyle.js";
import { GridContainer } from "components";
import PropTypes from "prop-types";
import React from "react";
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";

const useStyles = makeStyles(styles);

export default function CardBody(props) {
  const { className, children, plain, profile, ...rest } = props;
  const cardClasses = estilos(useStyles(), props, "body");

  return (
    <GridContainer>
      <div className={cardClasses} {...rest}>
        {children}
      </div>
    </GridContainer>
  );
}

CardBody.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  children: PropTypes.node
};